var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGmbLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 44,
    viewBox: "0 0 38 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector 9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2962 0.0910645L0.0910645 11.1369L8.68224 16.4552L18.2962 11.1369L28.7283 16.4552L37.7286 11.1369L18.2962 0.0910645Z",
    fill: "#EC2786"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.68224 16.4552L0.0910645 21.7736V33.2285L8.68224 38.1377L18.2962 33.2285L8.68224 27.7056V16.4552Z",
    fill: "#EC2786"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7283 38.1377L18.2962 33.2285V43.456L28.7283 38.1377Z",
    fill: "#EC2786"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7283 16.4552L19.5235 21.7736L28.7283 27.7056L37.7286 21.7736L28.7283 16.4552Z",
    fill: "#EC2786"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7286 21.7736L28.7283 27.7056V38.1377L37.7286 33.2285V21.7736Z",
    fill: "#90278E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmbLogo);
export default __webpack_public_path__ + "static/media/GMB_Logo.654d80c0a1e784358e651722cdf3a339.svg";
export { ForwardRef as ReactComponent };